import style from "./shapePicker.module.css";
import floatingStyles from "frontend/canvas-designer-new/elements-toolbar-cim-restyle/elements-toolbar.module.css";
import { ShapeInfo } from "frontend/types";
import { DropdownButton, Icon } from "../toolbar-buttons";
import AllShapes from "frontend/data/shapes/shapes-visuals";
import { calcDashProperties } from "frontend/utils/node-utils";
import { getPathPrefix } from "frontend/utils/getPathPrefix";

const BasicShapes: ShapeInfo[] = [
  { name: "Rectangle", shapeType: "rect" },
  { name: "Rounded rectangle", shapeType: "rounded-rect" },
  { name: "Circle", shapeType: "circle" },
  { name: "Triangle", shapeType: "triangle" },
  { name: "Diamond", shapeType: "diamond" },
  { name: "Hexagon", shapeType: "hexagon" },
  { name: "Pentagon", shapeType: "pentagon" },
  { name: "Pentagram", shapeType: "pentagram" },
  { name: "Octagon", shapeType: "octagon" },
  { name: "Hexagon", shapeType: "sideways-hexagon" },
  { name: "Trapezoid", shapeType: "trapezoid" },
  { name: "Flipped trapezoid", shapeType: "flipped-trapezoid" },
  { name: "Cloud", shapeType: "cloud" },
  { name: "Speech bubble", shapeType: "cloud-callout" },
  { name: "Callout", shapeType: "square-callout" },
  { name: "Annontation right", shapeType: "flat-annotation-right" },
  { name: "Annontation left", shapeType: "flat-annotation-left" },
  { name: "Arrow right", shapeType: "fat-arrow-right" },
  { name: "Arrow left", shapeType: "fat-arrow-left" },
  { name: "Arrow right+left", shapeType: "fat-arrow-both" },
];

export function ShapePicker({
  value: selectedShape,
  onChange: onShapeSelected,
  multi,
}: {
  value: string;
  onChange?: any;
  multi?: boolean;
}) {
  return (
    <DropdownButton
      tooltip="Shape"
      className={floatingStyles.popupContainer}
      data-testid="Shapepicker"
      renderPopup={() => {
        return (
          <div className={floatingStyles.threeRowGridLayout}>
            {BasicShapes.map((shape) => {
              const shapeData = AllShapes[shape.shapeType as keyof typeof AllShapes];
              if (!shapeData) {
                return null;
              }

              const strokeWidth = 1;
              const dash = calcDashProperties(strokeWidth, shape.dash);
              const dashStr = dash.dashEnabled ? dash.dash!.join(" ") : undefined;
              return (
                <div
                  key={shape.name + shape.shapeType}
                  data-testid={"basic-shape-" + shape.name}
                  role="button"
                  className={style.shapeIcon}
                  data-disabled={!multi && shape.shapeType === selectedShape}
                  onClick={() => onShapeSelected(shape.shapeType)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    fill="none"
                    stroke="white"
                    strokeWidth={2}
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <use
                      className="autocenter"
                      x={2}
                      y={2}
                      width={20}
                      height={20}
                      xlinkHref={`${getPathPrefix("/images/shapes_icons.svg")}#${shapeData.icon}`}
                      strokeDasharray={dashStr}
                      vectorEffect="non-scaling-stroke"
                    />
                  </svg>
                </div>
              );
            })}
          </div>
        );
      }}
    >
      <Icon icon="icon-shapes" />
    </DropdownButton>
  );
}
